<template>
  <AppInfo
    :subject="subject"
    :remetente="remetente"
    :destinatario="destinatario"
    :content="content"
    :dataEnviada="dataEnviada"
    :horaEnviada="horaEnviada"
    :dataEntrega="dataEntrega"
    :horaEntrega="horaEntrega"
    :dataLeitura="dataLeitura"
    :horaLeitura="horaLeitura"
    :emailRawDecoded="emailRawDecoded"
    :carimboEmail="carimboEmail"
    :carimboEmailEnvio="carimboEmailEnvio"
    :carimboEmailEntregue="carimboEmailEntregue"
    provider="qualisoft"
    :loading="loading"
    :error="error"
    :emailSent="emailSent"
  />
</template>
<script>
import AppInfo from '@/components/Info'
import { getRecovery } from './external.service'
export default {
  name: 'AppExternalPurged',

  data () {
    return {
      subject: '',
      remetente: '',
      destinatario: '',
      content: '',
      dataEnviada: '',
      horaEnviada: '',
      dataEntrega: '',
      horaEntrega: '',
      dataLeitura: '',
      horaLeitura: '',
      emailRawDecoded: '',
      carimboEmail: {},
      carimboEmailEnvio: {},
      carimboEmailEntregue: {},
      hasSuccess: true,
      loading: true,
      error: false
    }
  },

  components: { AppInfo },

  computed: {
    emailSent () {
      return !this.loading && this.hasSuccess
    }
  },

  mounted () {
    const idEmail = this.$route.params.idQualisoft
    getRecovery(idEmail)
      .then(response => {
        this.subject = response.subject
        this.remetente = response.remetente
        this.destinatario = response.destinatario
        this.content = response.content
        this.dataEnviada = response.dataEnviada
        this.horaEnviada = response.horaEnviada
        this.dataEntrega = response.dataEntrega
        this.horaEntrega = response.horaEntrega
        this.dataLeitura = response.dataLeitura
        this.horaLeitura = response.horaLeitura
        this.emailRawDecoded = response.emailRawDecoded
        this.carimboEmail = response.carimboEmail
        this.carimboEmailEnvio = response.carimboEmailEnvio
        this.carimboEmailEntregue = response.carimboEmailEntregue
        this.loading = false
      })
      .catch(() => {
        this.error = true
        this.loading = false
      })
  }
}
</script>
<style scoped>
@media (max-width:767px){
  .panel-body table * {
    width: 100% !important;
    table-layout: fixed !important;
  }
  .es-wrapper-color{zoom: 50%;}
  .panel-body table a img {
      width: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/external/ExternalPurged.vue